import { connect } from 'react-redux';
import { getProject, getSubCategory, getCategory } from 'project/ducks/project';
import HeaderTitle from 'project/components/header_title';
import idx from 'idx';

function mapStateToProps(state) {
  const project = getProject(state);
  return {
    project,
    category: getCategory(project, state.categories.data) || {},
    subCategory: getSubCategory(project, state.categories.data) || {},
    userId: idx(state, _ => _.user.profile_data.id),
  };
}

export default connect(mapStateToProps)(HeaderTitle);



// WEBPACK FOOTER //
// ./project/containers/header_title.jsx